var moment = require('moment')
import store from '../store'
export default {
    install(Vue) {
        // moment
        Vue.filter('$moment', (val, format) => {
            if (val) {
                if (!format) format = 'YYYY-MM-DD HH:mm:ss'
                return moment(val * 1000).format(format)
            } else {
                return '--'
            }
        }),
            // 金额千位符
            Vue.filter('$separator', value => {
                if (typeof value === 'number') {
                    return '¥ ' + value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
                }
            }),
            // 支付方式
            Vue.filter('$pay', id => {
                let _data = null
                store.state.payInfo.list.forEach(item => {
                    if (item.key === id) {
                        if (item.label) {
                            _data = '（' + item.label + '）' + item.value
                        } else {
                            _data = item.value
                        }
                    }
                })
                return _data
            }),
            // 发货方式
            Vue.filter('$express', id => {
                let _data = null
                store.state.expressInfo.list.forEach(group => {
                    group.options.forEach(item => {
                        if (item.key === id) {
                            if (item.label) {
                                _data = '（' + item.label + '）' + item.value
                            } else {
                                _data = item.value
                            }
                        }
                    })
                })
                return _data
            }),
            // 订单状态
            Vue.filter('$order', id => {
                let _data = null
                store.state.orderInfo.list.forEach(item => {
                    if (item.key === id) {
                        _data = item.value
                    }
                })
                return _data
            }),
            // 导航切换方法
            (Vue.prototype.$navigationOver = () => {
                let ul = event.currentTarget.childNodes[1]
                ul.classList.remove('fadeOutDown')
                ul.style.display = 'block'
            })
        Vue.prototype.$navigationLeave = () => {
            let ul = event.currentTarget.childNodes[1]
            ul.classList.add('fadeOutDown')
            setTimeout(() => {
                ul.classList.remove('fadeOutDown')
                ul.style.display = 'none'
            }, 40)
        }
        // 全局请求
        Vue.prototype.$request = obj => {
            return new Promise((resolve, reject) => {
                Vue.prototype
                    .$axios({
                        url: obj.url,
                        method: obj.method || 'GET',
                        headers: obj.headers,
                        // POST && PUT 参数方式
                        data: obj.data,
                        // GET && DELETE 参数方式
                        params: obj.params
                    })
                    .then(res => {
                        resolve(res)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }
        // 上传
        Vue.prototype.$upload = obj => {
            return new Promise((resolve, reject) => {
                Vue.prototype
                    .$request({
                        url: '/api/v1/uploadFile',
                        method: 'POST',
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        data: obj.data
                    })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }
    }
}
